import { render, staticRenderFns } from "./performTsksDetails.vue?vue&type=template&id=1e56afff&scoped=true"
import script from "./performTsksDetails.vue?vue&type=script&lang=js"
export * from "./performTsksDetails.vue?vue&type=script&lang=js"
import style0 from "./performTsksDetails.vue?vue&type=style&index=0&id=1e56afff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e56afff",
  null
  
)

export default component.exports